module.exports = WHCore.dependencies.react;